import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Settings, ArrowRight } from "lucide-react";
import { OnboardingChecklist } from "@/components/settings/OnboardingChecklist";
import { OnboardingWizard } from "@/components/settings/OnboardingWizard";

export default function DashboardSetupIncomplete({
  restaurant, stats, activationStatus,
  showWizard, setShowWizard, fetchData, authAxios, navigate,
}) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-4xl font-bold uppercase tracking-tight" data-testid="dashboard-title">
            {restaurant?.name || "MEU RESTAURANTE"}
          </h1>
          <p className="text-muted-foreground text-sm">
            {restaurant?.slug ? `/${restaurant.slug}` : "Configure seu restaurante"}
          </p>
        </div>
      </div>
      <OnboardingChecklist
        restaurant={restaurant}
        productCount={stats?.total_products || 0}
        categoryCount={stats?.total_categories || 0}
        onStartWizard={() => setShowWizard(true)}
        onActivated={fetchData}
        activationStatus={activationStatus}
      />
      {showWizard && (
        <OnboardingWizard
          key="wizard-setup-incomplete"
          open={true}
          onClose={() => { setShowWizard(false); sessionStorage.setItem("wizard_dismissed", "1"); fetchData(); }}
          authAxios={authAxios}
          restaurant={restaurant}
          onComplete={() => { fetchData(); navigate("/menu"); }}
        />
      )}
      <Card className="border-blue-200 bg-blue-50/50" data-testid="setup-required-message">
        <CardContent className="py-8 text-center space-y-3">
          <Settings className="w-12 h-12 mx-auto text-blue-400" />
          <p className="text-lg font-bold text-blue-800">Complete a configuracao do seu restaurante</p>
          <p className="text-sm text-blue-600">
            Depois de completar os passos acima, o dashboard completo, QR code, link do menu e todas as funcoes estarao disponiveis.
          </p>
          <Button className="bg-blue-600 hover:bg-blue-700 gap-2 mt-2" onClick={() => setShowWizard(true)} data-testid="setup-now-btn">
            <ArrowRight className="w-4 h-4" /> Configurar Agora
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
